import { Component, input, signal, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FtGoalSelectorComponent } from './ft-goal-selector.component';
import { FtIncentiveSelectorComponent } from './ft-incentive-selector.component';

/**
 * Native port of the AngularJS `ftEditGoals` directive — the body of the friends-goals
 * (`contestGoalsModal`) editor. Renders the update-goals + new-goals lists (each row: an
 * action menu + the native `ft-goal-selector-ng` / `ft-incentive-selector-ng` leaves) plus
 * the "Add goal" footer. A single `openMenuKey` pointer toggles the per-row action menu
 * without mutating the goal objects (a stray field would leak into the save diff).
 */
@Component({
    selector: 'ft-edit-goals-ng',
    imports: [TranslateModule, FtGoalSelectorComponent, FtIncentiveSelectorComponent],
    encapsulation: ViewEncapsulation.None,
    templateUrl: './ft-edit-goals.component.html',
    host: {
        '(document:click)': 'onDocumentClick()',
    }
})
export class FtEditGoalsComponent {
    /** The editGoalsModel `{ updateGoals, newGoals, deleteGoals }`. */
    readonly goals = input<any>();
    /** The warm-lead-tagged property incentives `{ item: [] }` (passed to each incentive selector). */
    readonly incentives = input<any>();
    /** The selected language object (v1 `culture`). */
    readonly culture = input<any>();
    /** The goal type for new goals (v1 `type`; 2 = friends). */
    readonly type = input<any>();

    /** v1 `ft-click-class toggle-class="active"` per-row pointer ('u'+i / 'n'+i); null = all closed. */
    protected readonly openMenuKey = signal<string | null>(null);

    /** v1 `addNewGoal` — push a fresh active goal of this type. */
    protected addNewGoal(): void {
        this.goals().newGoals.push({ isActive: 1, type: this.type() });
    }

    /** v1 `removeNewGoal` — drop the new goal at index. */
    protected removeNewGoal(index: number): void {
        this.goals().newGoals.splice(index, 1);
    }

    /** v1 `deactivate` / `activate` / `remove` / `restore` — flag flips. */
    protected deactivate(goal: any): void {
        goal.isActive = 0;
    }
    protected activate(goal: any): void {
        goal.isActive = 1;
    }
    protected remove(goal: any): void {
        goal.markedForRemoval = true;
    }
    protected restore(goal: any): void {
        goal.markedForRemoval = false;
    }

    protected toggleMenu(key: string, event: Event): void {
        event.stopPropagation();
        this.openMenuKey.update((openKey) => (openKey === key ? null : key));
    }

    protected onDocumentClick(): void {
        this.openMenuKey.set(null);
    }
}
